export default "__VITE_ASSET__074a0af1__"